import {
  Airplane16Regular,
  Airplane24Regular,
  Flag16Regular,
  Flag24Regular,
  Location16Regular,
  Location24Regular,
  Map16Regular,
  Map24Regular,
  Pin16Regular,
  Pin24Regular,
  PuzzlePiece16Regular,
  PuzzlePiece24Regular,
  Trophy16Regular,
  Trophy24Regular,
  VehicleCar16Regular,
  VehicleCar24Regular,
  Wrench16Regular,
  Wrench24Regular,
} from '@/components/Icon'

export const workspaceIconPackE = {
  car: { 16: VehicleCar16Regular, 24: VehicleCar24Regular },
  airplane: { 16: Airplane16Regular, 24: Airplane24Regular },
  map: { 16: Map16Regular, 24: Map24Regular },
  location: { 16: Location16Regular, 24: Location24Regular },
  pin: { 16: Pin16Regular, 24: Pin24Regular },
  flag: { 16: Flag16Regular, 24: Flag24Regular },
  trophy: { 16: Trophy16Regular, 24: Trophy24Regular },
  puzzle: { 16: PuzzlePiece16Regular, 24: PuzzlePiece24Regular },
  wrench: { 16: Wrench16Regular, 24: Wrench24Regular },
}
